module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"alert":"Agora você pode criar uma senha para sua conta.","configurePassword":"Configurar senha"},"en":{"alert":"Now you can create a password for your account.","configurePassword":"Configure password"}}')
  delete Component.options._Ctor
}
